{
  "page": {
    "title": "Dashboard",
    "mobileNotice": {
      "title": "Use desktop",
      "body": "The admin dashboard is optimised for screens 768px and wider. Open Printway on a desktop or rotate your tablet to view operational KPIs."
    },
    "kpiError": "KPIs unavailable — retrying.",
    "vendorActivityAria": "Vendor performance + activity"
  },
  "kpi": {
    "labels": {
      "total_merchants": "Total Merchants",
      "active_orders": "Active Orders",
      "gross_revenue": "Gross Revenue",
      "cogs": "COGS",
      "gross_margin": "Gross Margin",
      "avg_vendor_rating": "Avg Vendor Rating",
      "pending_topups": "Pending Topups",
      "open_support_tickets": "Open Support",
      "sync_errors_24h": "Sync Errors 24h",
      "order_warnings": "Order Warnings",
      "new_blueprints": "New Blueprints",
      "outstanding_invoices": "Outstanding Invoices"
    },
    "newBlueprintsBreakdown": "Pending {{pending}} · Rejected {{rejected}} · Approved {{approved}} · Rate {{rate}}",
    "gridAria": "Dashboard KPIs"
  },
  "quickActions": {
    "srHeading": "Quick actions",
    "pendingAria": "{{count}} pending",
    "reviewKyc": "Review KYC",
    "reviewTopups": "Review topups",
    "assignOrders": "Assign orders",
    "supportInbox": "Support inbox",
    "syncErrors": "Sync errors",
    "reviewBlueprints": "Review blueprints"
  },
  "alerts": {
    "srHeading": "Operational alerts",
    "unavailable": "Alerts unavailable — retrying.",
    "detail": "Detail",
    "viewAll": "View all ({{total}})",
    "categoryAria": "Category {{category}}",
    "categories": {
      "sla": "SLA",
      "capacity": "Capacity",
      "sync": "Sync"
    }
  },
  "activity": {
    "heading": "Recent activity",
    "refreshing": "Refreshing…",
    "loadError": "Unable to load activity feed.",
    "empty": "No recent activity.",
    "loadOlderError": "Unable to load older activity.",
    "loading": "Loading…",
    "loadOlder": "Load older",
    "end": "No older activity.",
    "entries": "{{count}} entries",
    "types": {
      "new_merchant": "New merchant signup",
      "large_order_500": "Large order (≥$500)",
      "sla_breach": "SLA breach",
      "sync_error": "Sync error",
      "topup_approval": "Top-up approval",
      "vendor_rating_change": "Vendor rating change",
      "impersonation_event": "Impersonation event"
    },
    "severity": {
      "info": "Info",
      "warning": "Warning",
      "critical": "Critical"
    },
    "relative": {
      "justNow": "just now",
      "minutes": "{{n}}m ago",
      "hours": "{{n}}h ago",
      "days": "{{n}}d ago"
    }
  },
  "charts": {
    "gridAria": "Dashboard charts",
    "loadFailed": "Failed to load chart.",
    "revenue": {
      "title": "Revenue trend",
      "subtitle": "Daily revenue (USD canonical,)"
    },
    "orderVolume": {
      "title": "Order volume",
      "subtitle": "Daily counts stacked by status"
    },
    "utilization": {
      "title": "Vendor utilization",
      "subtitle": "Top 10 vendors × 30 days"
    },
    "statusMix": {
      "title": "Order status mix",
      "subtitle": "Current distribution by status"
    },
    "topMerchants": {
      "title": "Top merchants by GMV",
      "subtitle": "Click a bar to open the merchant page"
    },
    "simple": {
      "loading": "Loading data…",
      "error": "Unable to load chart",
      "empty": "No data for this time range",
      "revenue": {
        "title": "Revenue",
        "subtitle": "USD by day"
      },
      "orders": {
        "title": "Order volume",
        "subtitle": "Orders created by day"
      },
      "utilization": {
        "title": "Vendor utilization rate",
        "subtitle": "Average utilization (%) by day"
      },
      "status": {
        "title": "Order status distribution",
        "subtitle": "Total orders by status"
      }
    }
  },
  "revenueChart": {
    "loadingAria": "Revenue trend chart loading",
    "figureAria": "Revenue trend line chart, last 30 days, USD",
    "empty": "No revenue data for the selected range."
  },
  "orderVolumeChart": {
    "loadingAria": "Order volume chart loading",
    "figureAria": "Order volume chart, daily counts stacked by status",
    "empty": "No order volume data for the selected range.",
    "series": {
      "pending": "Pending",
      "in_progress": "In progress",
      "shipped": "Shipped",
      "cancelled": "Cancelled"
    }
  },
  "orderStatusChart": {
    "loadingAria": "Order status distribution loading",
    "figureAria": "Order status distribution donut chart",
    "empty": "No order status data available.",
    "total": "Total"
  },
  "topMerchantsChart": {
    "loadingAria": "Top merchants by GMV chart loading",
    "figureAria": "Top merchants by GMV horizontal bar chart",
    "empty": "No merchant GMV data for the selected range."
  },
  "utilizationChart": {
    "loadingAria": "Vendor utilization heatmap loading",
    "figureAria": "Vendor utilization heatmap, top 10 vendors over 30 days",
    "empty": "No vendor utilization data for the selected range.",
    "day": "Day {{n}}"
  },
  "dateRange": {
    "presetsAria": "Date range presets",
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "presets": {
      "today": "Today",
      "last_7d": "Last 7 days",
      "last_30d": "Last 30 days",
      "this_month": "This month",
      "last_month": "Last month",
      "custom": "Custom"
    }
  },
  "vendorTable": {
    "heading": "Vendor performance",
    "tabsAria": "Vendor performance tabs",
    "tabTop": "Top Vendors",
    "tabIssues": "Vendors with Issues",
    "loadError": "Unable to load vendor performance.",
    "emptyTop": "No vendors meet the performance threshold yet.",
    "emptyIssues": "No vendors currently flagged with issues.",
    "columns": {
      "vendor": "Vendor",
      "rating": "Rating",
      "orders": "Orders",
      "backOrderRate": "Back-order rate",
      "utilization": "Utilization",
      "atRiskFlags": "At-Risk flags",
      "actions": "Actions"
    },
    "view": "View",
    "resolve": "Resolve"
  },
  "widgetGrid": {
    "title": "Dashboard",
    "saving": "Saving…",
    "addWidget": "+ Add widget",
    "resetDefault": "Reset to default",
    "loadError": "Unable to load dashboard layout.",
    "rangeErrorCurrent": "Layout must contain {{min}}-{{max}} widgets (currently {{count}}).",
    "rangeError": "Layout must contain {{min}}-{{max}} widgets.",
    "resetConfirmTitle": "Reset dashboard to default?",
    "resetConfirmDesc": "Your custom widget arrangement will be replaced with the default layout for your role. This cannot be undone.",
    "resetConfirm": "Reset",
    "cancel": "Cancel"
  },
  "widgetPicker": {
    "title": "Add or remove dashboard widgets",
    "description": "Select between {{min}} and {{max}} widgets. Layout is saved automatically when you click Apply.",
    "empty": "No widgets available for your role.",
    "tooFew": "Select at least {{min}} widgets (currently {{count}}).",
    "tooMany": "Select at most {{max}} widgets (currently {{count}}).",
    "selected": "{{count}} of {{max}} widgets selected.",
    "cancel": "Cancel",
    "apply": "Apply",
    "categories": {
      "kpi": "KPIs",
      "chart": "Charts",
      "table": "Tables",
      "feed": "Feeds",
      "other": "Other"
    }
  }
}
